import React, { useMemo, useState } from 'react'
import {
  Utils,
  Query,
  Builder,
  // types:
  BuilderProps,
  ImmutableTree,
  Config,
  JsonTree,
} from '@react-awesome-query-builder/mui'
import throttle from 'lodash/throttle'
import loadedConfig from './config_mui' // or ""./config_antd"
import './styles.scss'
import { FormControlLabel, Switch } from '@mui/material'

const stringify = JSON.stringify
const { jsonLogicFormat, queryString, getTree, checkTree, loadTree, uuid } =
  Utils
const preStyle = {
  // backgroundColor: 'darkgrey',
  // margin: '10px',
  padding: '0px 12px',
  // border: "1px solid #e8e8e8",
}

const emptyInitValue: JsonTree = { id: uuid(), type: 'group' }

const getInitValue = (initTree: JsonTree | undefined, config: Config) => {
  if (initTree && Object.keys(initTree).length > 0) {
    return checkTree(loadTree(initTree), config)
  }
  return checkTree(loadTree(emptyInitValue), loadedConfig)
}

type Props = {
  fields: any
  initialValue?: JsonTree
  onChange: (tree: JsonTree, config: Config) => void
}

function getAllFieldNames(obj: any) {
  let fieldNames: Array<String> = []

  function extractFields(obj: any) {
    for (const key in obj) {
      if (key === 'field') {
        // Add the field name if it's "field"
        fieldNames.push(obj[key])
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        // Recursively process nested objects
        extractFields(obj[key])
      }
    }
  }

  extractFields(obj)
  return fieldNames
}

export const QueryViewer = ({ value }: any) => {
  const config = useMemo(() => {
    try {
      const features = getAllFieldNames(
        typeof value === 'string' ? JSON.parse(value) : value
      )
      const _config: Config = {
        ...loadedConfig,
        fields: features.reduce((acc: any, feature: any) => {
          acc[feature] = {
            label: feature,
            type: 'number',
            preferWidgets: ['number'],
            valueSources: ['value'],
          }
          return acc
        }, {}) as any,
      }

      return _config
    } catch (error) {
      return loadedConfig
    }
  }, [value])

  const formatted = useMemo(() => {
    try {
      const tree = getInitValue(
        typeof value === 'string' ? JSON.parse(value) : value,
        config
      ) as ImmutableTree

      return queryString(tree, config, true)
    } catch (error) {
      return ''
    }
  }, [value, config])
  return <span>{formatted}</span>
}

const DatasetRulesBuilder = ({ fields, initialValue, onChange }: Props) => {
  const config = useMemo(() => ({ ...loadedConfig, fields }), [fields])
  const [tree, setTree] = useState(getInitValue(initialValue, config))
  const [isJsonTreeOpen, setIsJsonTreeOpen] = useState(false)

  const resetValue = () => {
    // setTree(initTree);
  }

  const clearValue = () => {
    setTree(loadTree(emptyInitValue))
  }

  const renderBuilder = (props: BuilderProps) => (
    <div className="query-builder-container">
      <div className="query-builder qb-lite" style={{ margin: 0 }}>
        <Builder {...props} />
      </div>
    </div>
  )

  const handleChange = (immutableTree: ImmutableTree, config: Config) => {
    // `jsonTree` or `logic` can be saved to the backend
    // (and then loaded with `loadTree` or `loadFromJsonLogic` as seen above)
    const jsonTree = getTree(immutableTree)
    const { logic, data, errors } = jsonLogicFormat(immutableTree, config)
    // Perform any necessary operations with jsonTree, logic, data, and errors
    // Update state or perform other actions as needed
    console.log('jsonTree: ', jsonTree)
    onChange(jsonTree, config)
    setTree(immutableTree)
  }

  const updateResult = throttle(() => {
    // Update the state with the current tree and config
    setTree(tree)
  }, 100)

  const renderResult = ({
    tree: immutableTree,
    config,
  }: {
    tree: ImmutableTree
    config: Config
  }) => {
    const { logic, data, errors } = jsonLogicFormat(immutableTree, config)
    return (
      <div>
        {/* humanStringFormat:
        <pre style={preStyle}>
          {stringify(queryString(immutableTree, config, true), undefined, 2)}
        </pre>
        <div>
          <a href="http://jsonlogic.com/play.html" target="_blank" rel="noopener noreferrer">
            jsonLogicFormat
          </a>:
          {errors && errors?.length > 0 && (
            <pre>{stringify(errors, undefined, 2)}</pre>
          )}
          {!!logic && (
            <pre style={preStyle}>
              {"// Rule"}:<br />
              {stringify(logic, undefined, 2)}
              <br />
              <hr />
              {"// Data"}:<br />
              {stringify(data, undefined, 2)}
            </pre>
          )}
        </div>
        <hr /> */}
        <div>
          <pre style={preStyle}>
            {stringify(getTree(immutableTree), undefined, 2)}
          </pre>
        </div>
      </div>
    )
  }

  return (
    <div className="dataset-rules-builder">
      <Query
        {...config}
        value={tree}
        onChange={handleChange}
        renderBuilder={renderBuilder}
      />
      {/* {renderResult({ tree, config })} */}
      {/* <button onClick={resetValue}>reset</button> */}
      {/* <button onClick={clearValue}>clear</button> */}
      <FormControlLabel
        sx={{ mt: 1, ml: 0 }}
        control={<Switch checked={isJsonTreeOpen} size='small' />}
        label="Show JSON Tree"
        onChange={() => setIsJsonTreeOpen(!isJsonTreeOpen)}
      />
      {isJsonTreeOpen && (
        <div className="query-builder-result">
          {renderResult({ tree, config })}
        </div>
      )}
    </div>
  )
}

export default DatasetRulesBuilder
